import React, { Component } from 'react';
import { Modal, Header, Button, Segment, Icon, Form, Popup, Message } from "semantic-ui-react";
import _ from 'lodash';
import parse from "html-react-parser";

import request from "../../../utils/request";

class ManualCTACardSelection extends Component {
    constructor (props) {
        super(props);

        this.state = {
            cardSet: [],
            suit: "",
            rank: "",
            isModalOpen: false,
            disableManualSelection: props?.disableManualSelection ?? false
        }
    }

    async componentDidMount() {
        let cardSet = await request.get(this, `api:/card-sets/${this.props.cardSetId}`, {});
        this.setState({ cardSet: cardSet });
    }

    handleRankChange = (e, data) => {
        let selectedRank = _.find(data.options, ({ value: data.value }));
        let rank = selectedRank?.rank['rank'] ?? "";

        this.handleChange(null, { name: "rank", value: rank });
    }

    handleSuitChange = (e, data) => {
        const { cardSet } = this.state;
        const ranks = _(cardSet.cards)
          .filter(x => x.suit === data.value)
          .map((value, key) => ({
            key: key,
            suit: key,
            rank: value,
            value: value.rank,
            ranktext: value.rankText,
            text: parse(value.rankText),
            color: value.length > 0 ? value[0].color : "#000"
          })).value();
        let selectedSuit = _.find(data.options, ({key: data.value}));

        // Auto-select card rank if suit selected is either RJ or BJ
        let rank = null;
        if (selectedSuit.suit === "RJ" || selectedSuit.suit === "BJ") rank = ranks[0]?.rank['rank'] ?? "";

        this.setState({ ranks: ranks, rank: rank });
        this.handleChange(null, { name: "suit", value: selectedSuit.suit });
    }

    handleChange = (e, { name, value }) => {
        this.setState({ [name]: value });
    }

    handleSubmit = e => {
        e.preventDefault();
        this.setState({ isLoading: true });

        const { suit, rank } = this.state;
        let payload = {
            suit: suit,
            rank: rank
        }
        request.post(this, `api:/event/${this.props.eventId}/winners/set-envelope-card`, payload).then(resp => {
            this.setState({
              xhrStatus: resp.success ? "success" : "error",
              xhrMessage: resp.message,
              disableManualSelection: resp.success,
              isLoading: false
            });
        });
    }

    handleCancel = () => {
        this.setState({ isModalOpen: false }, this.props.init);
    }

    handleOpen = () => {
        this.setState({ isModalOpen: true });
    }

    render() {
        const { cardSet, suit, rank, ranks, xhrStatus, xhrMessage, isModalOpen, disableManualSelection } = this.state;

        const suits = _(cardSet.cards)
        .groupBy(x => x.suit)
        .map((value, key) => ({
            key: key,
            suit: key,
            ranks: value,
            value: key,
            suittext: value.length > 0 ? value[0].suitText : "",
            text: parse(value.length > 0 ? value[0].suitText : ""),
            color: value.length > 0 ? value[0].color : "#000"
        })).value()

        return (
            <Modal
                trigger={<Button primary onClick={this.handleOpen}>Select Card Revealed</Button>}
                open={isModalOpen}
                closeIcon
                onClose={this.handleCancel}
                size="small"
            >
                <Header icon='envelope open' content='Select Card Revealed' />
                <Modal.Content>
                    <Message
                        header='NOTE!'
                        content='You will not be able to change your selection after this point.'
                        color='yellow'
                    />
                    <Form
                        success={xhrStatus === "success"}
                        error={xhrStatus === "error"}
                    >
                        {xhrStatus === "success" && <Message success content={xhrMessage} />}
                        {xhrStatus === "error" && <Message error content={xhrMessage} />}
                        <Form.Group>
                            <Form.Field required>
                                <Popup
                                    trigger={
                                    <label>
                                        <Icon name="help circle" color="blue" fitted /> {`Card Suit`}
                                    </label>
                                    }
                                    content={`Select the Card Suit`}
                                    inverted
                                    wide
                                />
                                <Form.Select
                                    name="suit"
                                    options={suits ?? []}
                                    value={suit ?? ""}
                                    onChange={this.handleSuitChange}
                                />
                            </Form.Field>
                            <Form.Field required>
                                <Popup
                                    trigger={
                                    <label>
                                        <Icon name="help circle" color="blue" fitted /> {`Card Rank`}
                                    </label>
                                    }
                                    content={`Select the Card Rank`}
                                    inverted
                                    wide
                                />
                                <Form.Select
                                    name="rank"
                                    options={ranks ?? []}
                                    value={rank ?? ""}
                                    onChange={this.handleRankChange}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Segment basic textAlign="right">
                            <Form.Field>
                                <Button content="Cancel" onClick={this.handleCancel} />
                                <Button primary content="Confirm" disabled={disableManualSelection} onClick={this.handleSubmit} />
                            </Form.Field>
                        </Segment>
                    </Form>
                </Modal.Content>
            </Modal>
        );
    }
}

export default ManualCTACardSelection;
